import React from 'react'
import PropTypes from 'prop-types'
import { Logo } from '../Logo'
import {
  withTranslation, TRANSLATION_VALUE_KEYS, TRANSLATION_KEYS
} from 'LiveBoard/hocs'
import get from 'lodash/get'

import './style.css.scss'

const StandardFooter = (props) => {
  const { headerLogo } = props.config

  return (
    <div className="standard-footer-wrapper">
      <div className="footer-content">
        { headerLogo.show && get(headerLogo, 'image.url') && 
          <Logo image={headerLogo.image} /> 
        }
        <div className="copyright">
          {props.getTranslation(TRANSLATION_VALUE_KEYS.createdBy)}
          <span className="folloze-logo" />
        </div>
      </div>
    </div>
  )
}

StandardFooter.propTypes = {
  config: PropTypes.object.isRequired
}

export default withTranslation(TRANSLATION_KEYS.standardFooter)(StandardFooter)